import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/summaryContainer.css';

const BookingSummaryView = ({logged_in, user}) => {
  const navigate = useNavigate();
  const [actionLog, setActionLog] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);  // State to store logs for selected booking


  // Load actionLog from localStorage on component mount
  useEffect(() => {
    const storedActionLog = localStorage.getItem('actionLog');
    if (storedActionLog) {
      setActionLog(JSON.parse(storedActionLog));
    }
  }, []);

  // Filter actionLog to show only the latest status of each booking
  const filteredActionLog = actionLog.reduce((acc, currentEntry) => {
    const existingIndex = acc.findIndex(
      (entry) => entry.trackingId === currentEntry.trackingId
    );

    if (existingIndex !== -1) {
      acc[existingIndex] = currentEntry;
    } else {
      acc.push(currentEntry);
    }

    return acc;
  }, []);

  // Filter for active and cancelled/deleted entries
  const activeBookings = filteredActionLog.filter(
    (entry) => entry.status !== 'cancelled' && entry.status !== 'Superseded' && entry.status !== 'deleted'
  );
  const cancelledBookings = filteredActionLog.filter(
    (entry) => entry.status === 'cancelled' || entry.status === 'Superseded' || entry.status === 'deleted'
  );

  // Show modal for full log of selected booking
  const handleViewLog = (trackingId) => {
    const fullLogForBooking = actionLog.filter(
      (logEntry) => logEntry.trackingId === trackingId
    );
    setSelectedLog(fullLogForBooking);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedLog(null);
  };

  return (

      <div className="summary-container">
        <h2>Booking Summary</h2>
          <button onClick={() => navigate(-1)} className="back-button">
            Back to Booking View
          </button>

        <div className="summary-section">
          <h3>Active Bookings</h3>
          {activeBookings.length === 0 ? (
            <p>No active booking actions to display.</p>
          ) : (
            <ul className="action-log-list">
              {activeBookings.map((logEntry) => (
                <li key={logEntry.trackingId} className="log-entry">
                  <div className="log-details">
                    <p><strong>Action:</strong> {logEntry.actionType}</p>
                    <p><strong>Doctor:</strong> {logEntry.doctor}</p>
                    <p><strong>Time:</strong> {new Date(logEntry.startTime).toLocaleString()} - {new Date(logEntry.endTime).toLocaleString()}</p>
                    <p><strong>Timestamp:</strong> {new Date(logEntry.timestamp).toLocaleString()}</p>
                    <p><strong>Status:</strong> {logEntry.status}</p>
                  </div>
                  {/* Add View Full Log button for this booking */}
                  <button onClick={() => handleViewLog(logEntry.trackingId)} className="view-log-button">
                    View Full Log
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="summary-section">
          <h3>Cancelled Bookings</h3>
          {cancelledBookings.length === 0 ? (
            <p>No cancelled or deleted actions to display.</p>
          ) : (
            <ul className="action-log-list">
              {cancelledBookings.map((logEntry) => (
                <li key={logEntry.trackingId} className="log-entry cancelled">
                  <div className="log-details">
                    <p><strong>Action:</strong> {logEntry.actionType} (Cancelled)</p>
                    <p><strong>Doctor:</strong> {logEntry.doctor}</p>
                    <p><strong>Time:</strong> {new Date(logEntry.startTime).toLocaleString()} - {new Date(logEntry.endTime).toLocaleString()}</p>
                    <p><strong>Timestamp:</strong> {new Date(logEntry.timestamp).toLocaleString()}</p>
                    <p><strong>Status:</strong> {logEntry.status} (Cancelled/Deleted)</p>
                  </div>
                
                  {/* Add View Full Log button for this booking */}
                  <button onClick={() => handleViewLog(logEntry.trackingId)} className="view-log-button">
                    View Full Log
                  </button>
                </li>
              ))}
              
            </ul>
          )}
        </div>

        {/* Modal for displaying full log of selected booking */}
        {showModal && (
          <>
            <div className="modal-overlay" onClick={handleModalClose}></div>
            <div className="modal">
              <button className="close-button" onClick={handleModalClose}>×</button>
              <h3>Booking History</h3>
              <div className="modal-content">
                <ul>
                  {selectedLog?.map((logEntry, index) => (
                    <li key={index}>
                      <p><strong>Action:</strong> {logEntry.actionType}</p>
                      <p><strong>Status:</strong> {logEntry.status}</p>
                      <p><strong>Time:</strong> {new Date(logEntry.startTime).toLocaleString()} - {new Date(logEntry.endTime).toLocaleString()}</p>
                      <p><strong>Timestamp:</strong> {new Date(logEntry.timestamp).toLocaleString()}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}
      </div>
      
  );
};

export default BookingSummaryView;
